import component from "./ProfileComments.vue"

import wrapVueComponent from "@/utils/wrapVueComponent"
const componentName = "StudentProfileComments"

export default wrapVueComponent(componentName, component)
